import * as React from "react";

interface VeboxAnimatorProps {
    from: number;
    to: number;
    curve?: (x: number) => number;
    map?: (x: number) => any;
    onUpdate?: (x: number) => void;
    duration: number;
}

export const VeboxAnimator: React.FC<VeboxAnimatorProps> = (props) => {

    const fps = 50;

    const [value, setValue] = React.useState<number>();

    const curve = (x) => (props.curve ?? AnimationCurves.linear)(x) * (props.to - props.from) + props.from;

    React.useLayoutEffect(() => {

        let step = 0;

        const intervalID = setInterval(() => {
            step += 1000 / fps;
            if (step >= props.duration) {
                clearInterval(intervalID);
                setValue(curve(1));
                if (props.onUpdate) {
                    props.onUpdate(curve(1));
                }
                return;
            }
            if (props.onUpdate) {
                props.onUpdate(curve(step / props.duration));
            }
            setValue(curve(step / props.duration));
        }, 1000 / fps);

    }, [props.from, props.to]);

    return (
        typeof props.children === "function"
            ? props.children(props.map ? props.map(value) : value)
            : props.children
    );
}

export namespace AnimationCurves {
    export function linear(x: number) {
        return x;
    }

    export function easeOutElastic(x) {
        const c4 = (2 * Math.PI) / 3;
        return x === 0
            ? 0
            : x === 1
                ? 1
                : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * c4) + 1;
    }

    export function easeOutCubic(x) {
        return 1 - Math.pow(1 - x, 3);
    }

    export function shake(x) {
        return Math.sin(Math.PI * x) * Math.sin(5 * Math.PI * x);
    }
}